import seliseLogo from 'assets/images/selise-ai-logo.svg';

export function AuthBrand() {
  return (
    <div className="flex items-center whitespace-nowrap">
      <img
        src={seliseLogo}
        className="h-10 w-auto object-contain"
        alt="SELISE AI logo"
      />
    </div>
  );
}
